@if (userData(); as userData) {
  <div class="sidebar__footer" [class.closed]="!isSidebarOpen()">
    <p class="user-name" @regularFontSizeAnimation>
      @if (isSidebarOpen()) {
        {{ userData.fullName }}
      } @else {
        {{ initials }}
      }
    </p>
    @if (isSidebarOpen()) {
      <p class="user-email" @smallFontSizeAnimation>
        {{ userData.email }}
      </p>
      <p-button
        @smallFontSizeAnimation
        (click)="logout.emit()"
        label="Log Out"
        styleClass="outline-button"
        pClass="sidebar__footer__btn">
        <i class="pi pi-sign-out sidebar__footer__sign-out-icon"></i>
      </p-button>
    } @else {
      <p-button
        pClass="action-button sidebar__footer__btn--short"
        [rounded]="true"
        (click)="logout.emit()"
        icon="pi pi-sign-out"
        severity="primary"></p-button>
    }
  </div>
}
